import React from "react";
import { FaPoll } from "react-icons/fa";

const notifyColor = "#51a197";

const operacoes = [
  {
    key: "campanha",
    label: "Campanha",
    icon: <FaPoll color={notifyColor} size={28} />,
    tipo: "radio",
  },
];

const Operacoes = ({ selected, setSelected, setEtapaAtual }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f7f7f7",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      <button
        style={{
          marginBottom: "20px",
          background: selected ? notifyColor : "#ccc",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          padding: "12px 24px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: selected ? "pointer" : "not-allowed",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          transition: "background 0.3s",
        }}
        onClick={() => {
          if (selected) setEtapaAtual(2);
        }}
        disabled={!selected}
      >
        Próximo
      </button>

      {/* Grid de Operações */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Responsivo: mínimo 250px por item
          gap: "20px", // Espaçamento entre os itens
          justifyItems: "center", // Centraliza os itens horizontalmente
          alignItems: "center", // Centraliza os itens verticalmente
          width: "100%",
          maxWidth: "900px", // Limita a largura máxima do grid
        }}
      >
        {operacoes.map((op) => (
          <div
            key={op.key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              background: "#f7f7f7",
              borderRadius: "12px",
              padding: "14px 18px",
              width: "100%",
              maxWidth: "300px", // Limita a largura máxima de cada item
              boxSizing: "border-box",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "38px",
              }}
            >
              {op.icon}
            </span>
            <span
              style={{
                flex: 1,
                fontWeight: "bold",
                color: "#005c53",
                fontSize: "16px",
                minWidth: 0,
              }}
            >
              {op.label}
            </span>
            {op.tipo === "radio" ? (
              <input
                type="radio"
                name="operacao"
                checked={selected === op.key}
                onChange={() => setSelected(op.key)}
                style={{
                  accentColor: notifyColor,
                  width: "22px",
                  height: "22px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <button
                style={{
                  background: notifyColor,
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                }}
                onClick={() => {
                  setSelected(op.key);
                  setEtapaAtual(2);
                }}
                title="Enviar Mensagem"
              >
                <FaPaperPlane color="#fff" size={18} />
              </button>
            )}
          </div>
        ))}
      </div>
      <style>
        {`
          @media (max-width: 600px) {
            div[style*="grid-template-columns"] {
              grid-template-columns: 1fr !important; /* Força 1 coluna em telas menores */
            }
          }
        `}
      </style>
    </div>
  );
};

export default Operacoes;